import Typography, { TypographyProps } from "@mui/material/Typography";

export default function ValueText(props: TypographyProps) {
  const { children, ...rest } = props;
  return (
    <Typography variant="body2" {...rest}>
      {children}
    </Typography>
  );
}
